import React from "react";

// Inline so the page carries no icon dependency of its own. Every icon inherits
// currentColor, so a parent's colour is the only thing that styles it.
const base = (size) => ({
  width: size,
  height: size,
  display: "block",
  flexShrink: 0,
});

export const RefreshIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" style={base(size)} aria-hidden="true">
    <path
      d="M20 12a8 8 0 1 1-2.34-5.66M20 4v4h-4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" style={base(size)} aria-hidden="true">
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
    <path d="m16.5 16.5 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const PencilIcon = ({ size = 14 }) => (
  <svg viewBox="0 0 24 24" fill="none" style={base(size)} aria-hidden="true">
    <path
      d="M4 20h4L20 8l-4-4L4 16v4Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" style={base(size)} aria-hidden="true">
    <path d="m6 6 12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ClockIcon = ({ size = 13 }) => (
  <svg viewBox="0 0 24 24" fill="none" style={base(size)} aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const CalendarIcon = ({ size = 13 }) => (
  <svg viewBox="0 0 24 24" fill="none" style={base(size)} aria-hidden="true">
    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const WarningIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="none" style={base(size)} aria-hidden="true">
    <path
      d="M12 3l9 16H3l9-16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M12 9v4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="16.5" r="1" fill="currentColor" />
  </svg>
);

export const PendingIcon = ({ size = 12 }) => (
  <svg viewBox="0 0 24 24" fill="none" style={base(size)} aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M12 8v4l2.5 2.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Which icon fronts a chip is a property of the field type, not of the section.
export const fieldIcon = (type) => (type === "date" ? CalendarIcon : ClockIcon);
